<template>
<div class="relative-position">
  <Cards class="margin-center " :posts="filteredCards" :tagSelection="tagSelection"/>
  <div class="tag-back" >

     <q-btn class="font back-btn"  @click="tagBack" color="primary" icon="history" label="Back" />
    <q-chip class="tag-chip font"  text-color="white" icon="tag" :label="label" />
       
  </div>
  </div>
</template>

<script>
import { computed, onMounted, onUpdated, ref } from 'vue'
import Cards from '@/components/Cards.vue'
import getPosts from '@/composables/getposts'
import { useRoute, useRouter } from 'vue-router'
export default {
  components: { Cards },
  setup() {

    onUpdated (() => {
      tagFunction()
    })

    let tagSelection  = ref([''])
    const { posts } = getPosts()
    const route = useRoute()
    const router = useRouter()
    let label  = ref()

     
    //  console.log(route.path === '/tag/level_3-5')


    const tagFunction = () => {
      const { tag } = route.params


      label.value = tag.split("_").join(" ")
      

      // tag.value = label

      return { tag }
    }
     

    const tagBack = () => {
      router.go(-1)
    }

    
  tagFunction()


    let testThree  = ref([])
      const filteredCards = computed(() => {
      const tagsFilter = posts.value.filter(p => p.tags.includes(route.params.tag))
      return tagsFilter
    })  


    return { filteredCards, posts, route, router, tagSelection, tagBack, tagFunction,  tagFunction, label }
  }
}
</script>

